// Third-party libraries
import React, { Fragment } from "react";

import { Meta } from "../utilities";

function Privacy() {
  return (
    <Fragment>
      <Meta
        title="Privacy Policy"
        description="Privacy policy for Rouleur Derby, almost certainly the best fantasy cycling game in the world."
      />
      <h1>Privacy Policy</h1>

      <p>
        This Privacy Policy describes how your personal information is
        collected, used, and shared when you visit Rouleur Derby (the "Site").
      </p>

      <h4>1. Personal Information We Collect</h4>

      <p>
        When you visit the Site, we automatically collect certain information
        about your device, including information about your Web browser, IP
        address, time zone, and some of the cookies that are installed on your
        device. Additionally, as you browse the Site, we collect information
        about the individual Web pages you view, what websites or search terms
        referred you to the Site, and information about how you interact with
        the Site. We refer to this automatically-collected information as
        "Device Information."
      </p>

      <p>We collect Device Information using the following technologies:</p>
      <ul>
        <li>
          “Cookies” are data files that are placed on your device or computer
          and often include an anonymous unique identifier. For more information
          about cookies, and how to disable cookies, visit{" "}
          <a href="http://www.allaboutcookies.org">
            http://www.allaboutcookies.org
          </a>
          . Note, however, that disabling cookies may disrupt or disable your
          ability to use the Site.
        </li>
        <li>
          “Log files” track actions occurring on the Site and collect data
          including your IP address, browser type, Internet service provider,
          referring/exit pages, and date/time stamps.
        </li>
      </ul>

      <h4>2. Google Analytics</h4>
      <p>
        Google Analytics is a Web analytics service offered by Google that
        tracks and reports website traffic. Google uses the data collected to
        track and monitor the use of the Site. This data is shared with other
        Google services. Google may use the collected data to contextualize and
        personalize the ads of its own advertising network, including
        remarketing. You may contact Google to{" "}
        <a href="https://www.google.com/settings/ads/anonymous">
          opt out of such targeting
        </a>
        . For more information about how targeted advertising works, you can
        visit the{" "}
        <a href="http://www.networkadvertising.org/understanding-online-advertising/how-does-it-work">
          Network Advertising Initiative's ("NAI") educational page
        </a>
        .
      </p>

      <p>
        No personally identifying information is shared with Google Analytics.
      </p>

      <p>
        For more information on the privacy practices of Google, please visit
        the{" "}
        <a href="http://www.google.com/intl/en/policies/privacy/">
          Google Privacy & Terms Web page
        </a>
        .
      </p>

      <p>
        Combined with the Device Information that we collect, Google Analytics
        help us screen for potential risk and fraud (in particular, your IP
        address), and more generally to improve and optimize our Site (for
        example, by generating analytics about how players browse and interact
        with the Site, and to assess the success of our marketing and
        advertising campaigns). It is critical to protecting the integrity and
        fairness of the Site.
      </p>

      <p>
        You can opt-out of having made your activity on the Service available to
        Google Analytics by installing the
        <a href="https://tools.google.com/dlpage/gaoptout">
          {" "}
          Google Analytics opt-out browser add-on
        </a>
        . The add-on prevents the Google Analytics JavaScript from sharing
        information with Google Analytics about visits and activity.
      </p>

      <h4>3. How Do We Use Your Personal Information?</h4>

      <p>
        When you create an account with the Site, you are required provide your
        email address, a username, and screen name. Optionally you may also
        provide your location and other personal information, including social
        media identity and home page. This optional information will be public
        on your profile page, but your email address will be hidden and will
        never be shared with other players.
      </p>

      <p>
        We may use your email address to contact you for purposes of game
        mechanics and to provide customer service. If such interaction is not
        essential to your participation, an opt-out will be provided. The only
        broadcast email you may receive will be via an opt-in newsletter. Each
        newsletter message will include unsubscribe link in each message.
      </p>

      <h4>4. Sharing Your Personal Information</h4>

      <p>
        We will not share your personal information with any third party without
        your explicit consent, such as if you choose to opt in to the newsletter
        of Wide Angle Podium, one of the site's partners, or to satisfy a
        critical piece of the site's infrastructure, such as providing your
        email to the Site's newsletter service provider (Mailchimp) or to verify
        your membership at Wide Angle Podium.{" "}
      </p>

      <p>
        If the Site is ever sold, you will have the opportunity to opt out of
        having your information transferred to the new owners as part of the
        site's assets.
      </p>
      <p>
        Finally, we may also share your personal information to comply with
        applicable laws and regulations, to respond to a subpoena, search
        warrant or other lawful request for information we receive, or to
        otherwise protect our rights.
      </p>

      <h4>5. Do Not Track</h4>
      <p>
        Please note that we do not alter our Site's data collection and use
        practices when we see a Do Not Track signal from your browser.
      </p>

      <h4>6. Your Rights</h4>
      <p>
        If you are a European resident, you have the right to access personal
        information we hold about you and to ask that your personal information
        be corrected, updated, or deleted. If you would like to exercise this
        right, please contact us through the contact information below.
      </p>

      <p>
        Additionally, please note that your information will be transferred
        outside of Europe, including to the United States.
      </p>

      <h4>7. Minors</h4>
      <p>The Site is not intended for individuals under the age of 18.</p>

      <h4>8. Changes</h4>
      <p>
        We may update this privacy policy from time to time in order to reflect,
        for example, changes to our practices or for other operational, legal,
        or regulatory reasons.
      </p>

      <h4>9. Contact Us</h4>
      <p>
        For more information about our privacy practices, if you have questions,
        or if you would like to make a complaint, please contact at{" "}
        <a href="mailto:info@rouleurderby.com">info@rouleurderby.com</a> or by
        mail using the details provided below:
      </p>

      <p>
        Climber Media LLC
        <br />
        ATTN: Luke Seemann
        <br />
        1928 Grant St.
        <br />
        Evanston, IL 60201
        <br />
        United States
      </p>

      <p>This Policy was last changed on March 11, 2019.</p>
    </Fragment>
  );
}

export default Privacy;
